import { Injector } from '@angular/core';

/**
 * Utility class to inject services directly in base classes
 * https://stackoverflow.com/questions/56748951/angular-inject-service-into-base-class-but-not-in-sub-class-and-use-the-parent-s
 */
export class AppInjector {

  private static injector: Injector;

  static setInjector(injector: Injector) {
    AppInjector.injector = injector;
  }

  static getInjector(): Injector {
    return AppInjector.injector;
  }
}
